import { useRef, useState } from 'react';

import { ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import Loading from 'components/Loading';
import ErrorDialog from 'components/ErrorDialog';
import { update as updateCouncil } from 'apis/councils.api';

export default function ConfirmDeleteMemberDialog({
  visible,
  setVisible,
  data,
  refetch,
  reset,
  watch,
  setIsSentMail,
}) {
  const { t } = useTranslation();
  const [isVisibleErrorDialog, setIsVisibleDialogError] = useState(false);
  const { mutate, isLoading, isError, error } = useMutation(updateCouncil);
  const toast = useRef(null);
  const accept = () => {
    data.append('isForce', 'true');
    mutate(data, {
      onSuccess: (res) => {
        toast.current.show({
          severity: 'success',
          summary: t('council.edit.success'),
          life: 2500,
        });
        const currentValues = watch();
        refetch();
        setIsSentMail(false);
        if (data.decisionToEstablish && res?.data?.establishmentFileUrl) {
          currentValues.decisionToEstablishFileUrl = res?.data?.establishmentFileUrl;
        }
        reset({
          ...currentValues,
          decisionToEstablish: null,
        });
      },
      onError: () => {
        setVisible(false);
        setIsVisibleDialogError(true);
      },
    });
  };

  return (
    <>
      {isLoading && <Loading />}
      {isError && (
        <ErrorDialog
          title={t('council.deleteMember.titleDeleteError')}
          isError={isError}
          error={error}
          visible={isVisibleErrorDialog}
          setVisible={setIsVisibleDialogError}
        />
      )}
      <Toast ref={toast} />
      <ConfirmDialog
        visible={visible}
        className="p-text-center w-3"
        onHide={() => setVisible(false)}
        // eslint-disable-next-line react/no-unstable-nested-components
        message={() => (
          <div className="mr-6 ml-1">
            <span>{t('council.deleteMember.confirm.messageBeforeCouncilName')} </span>
            <b>{data?.name}</b>
            <span className="font-bold">{t('council.deleteMember.confirm.containReview')}</span>
          </div>
        )}
        header={t('council.deleteMember.confirm.header')}
        icon="pi pi-exclamation-triangle text-red-500"
        accept={accept}
      />
    </>
  );
}

ConfirmDeleteMemberDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  setIsSentMail: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
};
